import { render, staticRenderFns } from "./FinishPage.vue?vue&type=template&id=da2fc19a&scoped=true&"
import script from "./FinishPage.vue?vue&type=script&lang=ts&"
export * from "./FinishPage.vue?vue&type=script&lang=ts&"
import style0 from "./FinishPage.vue?vue&type=style&index=0&id=da2fc19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2fc19a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
